export default "__VITE_ASSET__0365f210__"